import { logger } from '../utils/logger';

// Environment detection
const apiUrl = import.meta.env.VITE_DATA_URL || '';
const isLocalDev = apiUrl.includes('localhost');
const isDev = apiUrl.includes('dev.openparachute.dev');
const isStage = apiUrl.includes('stage.openparachute.dev');
const isProd = apiUrl.includes('learn.openparachuteschools.com');

// Configuration for the translation service
let translationApiUrl;

if (isLocalDev) {
  translationApiUrl = 'http://localhost:3000/local/graphql';
} else if (isDev) {
  translationApiUrl = 'https://api.dev.openparachute.dev/dev/graphql';
} else if (isStage) {
  translationApiUrl = 'https://api.stage.openparachute.dev/dev/graphql';
} else if (isProd) {
  translationApiUrl = 'https://api.learn.openparachuteschools.com/dev/graphql';
} else {
  // Default fallback
  translationApiUrl = 'https://api.learn.openparachuteschools.com/dev/graphql';
}

export const TRANSLATION_API_URL = translationApiUrl;

// Log the environment and API URL
logger.info(`Translation environment: ${isLocalDev ? 'Local Development' : isDev ? 'Development' : isStage ? 'Staging' : 'Production'}`);
logger.info(`Translation API URL: ${TRANSLATION_API_URL}`);

// CORS configuration with proper headers
export const TRANSLATION_API_CORS = {
  mode: 'cors' as RequestMode,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': isLocalDev
      ? 'http://localhost:4001, http://localhost:4000'
      : isDev
        ? 'https://dev.openparachute.dev'
        : isStage
          ? 'https://stage.openparachute.dev'
          : 'https://learn.openparachuteschools.com'
  }
};
